import { ApproverList, ApproverResponse, ApproverType } from '@cdaas/api-clients/dist/asset-user-openapi';

import { UserGroup } from '../types';

export const convertApprovalChainFromUserGroup = (approvalChain: ApproverResponse[], userGroup: UserGroup): ApproverList => ({
  contents: [{ name: userGroup.name, id: userGroup.id!, type: ApproverType.UserGroup }, ...approvalChain],
});

/**
 * Simply omits the first element from the approval chain.
 * First element is the user group itself, and is used solely for UI logic. It must not be sent to the API.
 * @param approvalChain
 */
export const convertApprovalChainToApiRequest = (approvalChain: ApproverList): ApproverList => ({ contents: approvalChain.contents.slice(1) });
